/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BulkJobParametersEntityIdsItem } from './bulkJobParametersEntityIdsItem';
import type { BulkJobParametersOptions } from './bulkJobParametersOptions';

/**
 * job definition
 */
export interface BulkJobParameters {
  operations: string[];
  entityIds: BulkJobParametersEntityIdsItem[];
  options?: BulkJobParametersOptions;
}
